import React from 'react';
import './styles.sass';
import { getNameForScore } from 'components/Explorer/util/sentiment_helpers';
import { kebabCase } from 'lodash-es';

const SentimentSwatch = ({ sentimentScore }) => {
  const sentimentName = sentimentScore !== null ? getNameForScore(sentimentScore) : 'Sentiment Analysis pending';
  const sentimentClassName = kebabCase(sentimentName);

  return (
    <div className="Mentions-Output-Sentiment-Swatch">
      <div className={`sentiment-icon ${sentimentClassName}`} data-testid="sentiment-icon" aria-hidden="true"></div>
      <p>{sentimentName}</p>
    </div>
  );
};

export default SentimentSwatch;
